import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const handleScroll = (e, targetId) => {
    e.preventDefault();

    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    } else {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }

    setIsOpen(false);
  };

  // ✅ Menu order fixed
  const menuItems = [
    { name: "Our Products", href: "/products", link: true },
    { name: "Solutions", href: "our-solution", scroll: true },
    { name: "Career", href: "/careers", link: true },
    { name: "Contact Us", href: "contact", scroll: true },
  ];

  return (
    <motion.nav
      className="bg-[#0A2A43]/90 backdrop-blur-md text-white fixed top-0 w-full z-50 shadow-lg border-b border-[#1E90FF]/40"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        {/* ✅ Logo + Brand */}
        <motion.div
          className="flex items-center space-x-3 cursor-pointer"
          whileHover={{ scale: 1.05 }}
          onClick={() => navigate("/")}
        >
          <motion.img
            src="/SPK _ MAK LOGO (2).jpg"
            alt="SPK MAK Logo"
            className="w-10 h-10 object-contain"
            whileHover={{
              rotate: 360,
              transition: { duration: 1, ease: "linear" },
            }}
          />
          <span className="text-lg md:text-xl font-bold text-[#1E90FF] tracking-wide">
            SPK MAK TECHNOLOGIES
          </span>
        </motion.div>

        {/* ✅ Desktop Menu */}
        <ul className="hidden md:flex space-x-6 lg:space-x-8 font-medium relative">
          {menuItems.map((item, index) => (
            <motion.li
              key={index}
              className="relative group"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
            >
              {item.link ? (
                <Link
                  to={item.href}
                  className="hover:text-[#87CEEB] transition duration-200 relative after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-[#87CEEB] after:transition-all after:duration-300 hover:after:w-full"
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              ) : (
                <a
                  href={`#${item.href}`}
                  onClick={(e) => handleScroll(e, item.href)}
                  className="hover:text-[#87CEEB] transition duration-200 relative after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] after:bg-[#87CEEB] after:transition-all after:duration-300 hover:after:w-full cursor-pointer"
                >
                  {item.name}
                </a>
              )}
            </motion.li>
          ))}
        </ul>

        {/* ✅ Mobile Menu Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden focus:outline-none"
        >
          <div className="space-y-1">
            <motion.div
              className="w-6 h-0.5 bg-white"
              animate={{ rotate: isOpen ? 45 : 0, y: isOpen ? 7 : 0 }}
            ></motion.div>
            <motion.div
              className="w-6 h-0.5 bg-white"
              animate={{ opacity: isOpen ? 0 : 1 }}
            ></motion.div>
            <motion.div
              className="w-6 h-0.5 bg-white"
              animate={{ rotate: isOpen ? -45 : 0, y: isOpen ? -7 : 0 }}
            ></motion.div>
          </div>
        </button>
      </div>

      {/* ✅ Mobile Dropdown Menu */}
      {isOpen && (
        <motion.div
          className="md:hidden bg-[#0D3B66] px-6 py-4 space-y-4 border-t border-[#1E90FF]/40"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          {menuItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ x: -30, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              {item.link ? (
                <Link
                  to={item.href}
                  className="block hover:text-[#87CEEB] transition duration-200"
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              ) : (
                <a
                  href={`#${item.href}`}
                  onClick={(e) => handleScroll(e, item.href)}
                  className="block hover:text-[#87CEEB] transition duration-200 cursor-pointer"
                >
                  {item.name}
                </a>
              )}
            </motion.div>
          ))}
        </motion.div>
      )}
    </motion.nav>
  );
}
export default Navbar;
